export const STRIPE_URL = "https://buy.stripe.com/00wcN61I1gJEaLhc9c1ZS02";
export const EMAIL = "info@ey-technology.com";
export const ADDRESS_LINES = [
  "EY TECH LLC",
  "520 Robinson Ln",
  "Unit 4 E 22",
  "19805 Wilmington / Delaware",
  "USA",
];
